module.exports = __webpack_public_path__ + "img/system-shutdown.89fda1c8.png";